import { create } from 'zustand';
import { PaymentMethodState } from './interfaces';
import { Order, PaymentMethod } from '@interfaces';

const usePaymentMethodStore = create<PaymentMethodState>()((set) => ({
  mekiCreditsChecked: false,
  insuranceId: null,
  totalReimbursement: 0,
  totalDeductible: 0,
  totalCopay: 0,
  orders: [],
  ordersTotal: 0,
  paymentMethods: [],
  actions: {
    setMekiCreditsChecked: (to: boolean) => {
      set({ mekiCreditsChecked: to });
    },
    setInsuranceId: (to: number) => {
      set({ insuranceId: to });
    },
    setInsuranceTotalInfo: (info: {
      insuranceId: number;
      totalReimbursement: number;
      totalDeductible: number;
      totalCopay?: number;
    }) => {
      set({
        insuranceId: info.insuranceId,
        totalReimbursement: info.totalReimbursement,
        totalDeductible: info.totalDeductible,
        totalCopay: info.totalCopay,
      });
    },
    setOrders: (to: Order[]) => {
      set({ orders: to });
    },
    setOrdersTotal: (to: number) => {
      set({ ordersTotal: to });
    },
    setPaymentMethods: (to: PaymentMethod[]) => {
      set({ paymentMethods: to });
    },
    cleanValues: () => {
      set({
        mekiCreditsChecked: false,
        insuranceId: null,
        totalReimbursement: 0,
        totalDeductible: 0,
        totalCopay: 0,
        orders: [],
        ordersTotal: 0,
        paymentMethods: [],
      });
    },
  },
}));

export const usePaymentSelectors = () =>
  usePaymentMethodStore((state) => {
    return {
      mekiCreditsChecked: state.mekiCreditsChecked,
      insuranceId: state.insuranceId,
      totalReimbursement: state.totalReimbursement,
      totalDeductible: state.totalDeductible,
      totalCopay: state.totalCopay,
    };
  });

export const useOrderAndPaymentInfo = () =>
  usePaymentMethodStore((state) => {
    return {
      orders: state.orders,
      ordersTotal: state.ordersTotal,
      paymentMethods: state.paymentMethods,
    };
  });

export const usePaymentMethodActions = () =>
  usePaymentMethodStore((state) => state.actions);
